export const ODV_TIMESLOT = Object.freeze({
  MORNING: { id: 'morning', key: 'general_morning' },
  AFTERNOON: { id: 'afternoon', key: 'general_afternoon' },
  EVENING: { id: 'evening', key: 'general_evening' },
  DAY: { id: 'day', key: 'general_full_day' },
})

// All labels an ODV can get (see useTimings.js), in chronological order. The search filter has no night option, the manage tables do.
export const ODV_TIMESLOT_LABELS = Object.freeze([
  ODV_TIMESLOT.MORNING,
  ODV_TIMESLOT.AFTERNOON,
  ODV_TIMESLOT.EVENING,
  { id: 'night', key: 'general_night' },
  ODV_TIMESLOT.DAY,
])
